<template>
  <div class="container">
    <Header />
    <div>
      <div>
        <FullMap
                v-if="curMap == 0 && MapData"
                title=""
                legendTop="57%"
                :areaCode="MapData.areaCode"
                :mapData="MapData.mapData"
                :legendConf="MapData.legendConf"
                :itemList="MapData.itemList"
        />
      </div>





      <div class="map-title" v-if="MapData">
        <div class="text">
          {{ MapData.title }}
        </div>
        <div class="tab">
          <div @click="curMap = 0" :class="{ current: curMap == 0 }">
            地图模式
          </div>
          <div @click="curMap = 1" :class="{ current: curMap == 1 }">
            列表模式
          </div>
        </div>

        <div style="height: 20px"></div>
          <div v-if="curMap == 1">
           <BScroll>
            <YuqingliebiaoCP
                    id="yuqingliebiaoChart"
                    :chartData="yuqingliebiaoData"
                    v-if="yuqingliebiaoData"/>
    </BScroll>
        </div>
      </div>




      <div class="left-content">
        <BScroll>
          <div>
            <BasePanel title="告警面板">
              <GaojingCP
                      id="gaojingChart"
                      :chartData="gaojingData"
                      v-if="gaojingData"/>
            </BasePanel>

            <BasePanel title="事件级别">
              <EventLevelCP
                      id="eventLevelChart"
                      :chartData="eventLevelData"
                      v-if="eventLevelData"/>
            </BasePanel>

            <BasePanel title="舆情变化趋势" code="601">
              <YuqingbianhuaqushiCP
                      id="yuqingbianhuaqushiChart"
                      :chartData="yuqingbianhuaqushiData"
                      v-if="yuqingbianhuaqushiData"/>
            </BasePanel>

            <BasePanel title="舆情风险度">
              <YuqingfengxianduCP
                      id="yuqingfengxianduChart"
                      :chartData="yuqingfengxianduData"
                      v-if="yuqingfengxianduData"/>
            </BasePanel>
          </div>
        </BScroll>
      </div>

      <div class="right-content">
        <BScroll>
          <div>
            <BasePanel title="舆情类型分析" code="602">
              <YuqingleixingfenxiCP
                      id="yuqingleixingfenxiChart"
                      :chartData="yuqingleixingfenxiData"
                      v-if="yuqingleixingfenxiData"/>
            </BasePanel>

            <BasePanel title="负面评价关键词" code="603">
              <JingquPingceCiyunCP id="fumianpingjiaguanjianciChart"
                                   :chartData="fumianpingjiaguanjianCiyunData"
                                   v-if="fumianpingjiaguanjianCiyunData"/>
            </BasePanel>

            <BasePanel title="主要舆情来源" code="604">
              <ZhuyaoyuqinglaiyuanCP
                      id="zhuyaoyuqinglaiyuanChart"
                      :chartData="zhuyaoyuqinglaiyuanData"
                      v-if="zhuyaoyuqinglaiyuanData"/>
            </BasePanel>

          </div>
        </BScroll>
      </div>

    </div>
  </div>
</template>

<script>
import Header from "@/components/Common/Header.vue";
import BScroll from "@/components/Common/BScroll.vue";
import BasePanel from "@/components/Common/BasePanel.vue";
import FullMap from "@/components/FullMap.vue";

import YuqingbianhuaqushiCP from "@/components/Lvyouyulun/Yuqingbianhuaqushi.vue";
import GaojingCP from "@/components/Lvyouyulun/Gaojing.vue";
import EventLevelCP from "@/components/Lvyouyulun/EventLevel.vue";
import YuqingfengxianduCP from "@/components/Lvyouyulun/Yuqingfengxiandu.vue";
import YuqingleixingfenxiCP from "@/components/Lvyouyulun/Yuqingleixingfenxi.vue";

import JingquPingceCiyunCP from "@/components/Echarts/JingquKoubei/JingquPingceCiyun.vue";
import ZhuyaoyuqinglaiyuanCP from "@/components/Lvyouyulun/Zhuyaoyuqinglaiyuan.vue";
import YuqingliebiaoCP from "@/components/Lvyouyulun/Table.vue";



export default {
  name: "lvyouyulun",
  components: {
    Header,
    BasePanel,
    BScroll,
    FullMap,


    YuqingbianhuaqushiCP,
    GaojingCP,
    EventLevelCP,
    YuqingfengxianduCP,
    YuqingleixingfenxiCP,
    JingquPingceCiyunCP,
    ZhuyaoyuqinglaiyuanCP,
    YuqingliebiaoCP
  },
  data() {
    return {
      curMap: 0,
      MapData: null,
      yuqingbianhuaqushiData: null,
      gaojingData: null,
      eventLevelData: null,
      yuqingfengxianduData: null,
      yuqingleixingfenxiData: null,
      zhuyaoyuqinglaiyuanData: null,
      yuqingliebiaoData: null,
      fumianpingjiaguanjianCiyunData: null
    };
  },
  mounted() {
    this.$store.commit("setPageName", "旅游舆论");
    this.$store.commit("setPageCode", 2);
    // 请求地图数据
    fetch("/data/Lvyouyulun/MapData.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.MapData = json.data;
        });
    // 舆情列表数据
    fetch("/data/Lvyouyulun/YuqingTableData.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.yuqingliebiaoData = json.data;
        });

    // 告警面板
    fetch("/data/Lvyouyulun/Gaojing.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.gaojingData = json.data;
        });
    // 事件级别
    fetch("/data/Lvyouyulun/EventLevel.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.eventLevelData = json.data;
        });
    // 舆情变化趋势
    fetch("/data/Lvyouyulun/Yuqingbianhuaqushi.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.yuqingbianhuaqushiData = json.data;
        });
    // 舆情风险度
    fetch("/data/Lvyouyulun/Yuqingfengxiandu.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.yuqingfengxianduData = json.data;
        });
    // 舆情类型分析
    fetch("/data/Lvyouyulun/Yuqingleixinfenxi.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.yuqingleixingfenxiData = json.data;
        });

    // 主要舆情来源
    fetch("/data/Lvyouyulun/Zhuyaoyuqinglaiyuan.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.zhuyaoyuqinglaiyuanData = json.data;
        });
    // 负面评价关键词云
    fetch("/data/Lvyouyulun/Fumianpingjiaguanjianciyun.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.fumianpingjiaguanjianCiyunData = json.data;
        });

  },
  methods: {}
};
</script>
<style scoped lang="less">
  .map-title {
    width: 4rem;
    height: 0.3rem;
    margin: 0.3rem auto 0;
    color: @light-blue;
    font-size: 0.2rem;
    font-weight: bold;
    position: relative;
    z-index: 9999;
    .tab {
      width: 2rem;
      height: 0.22rem;
      margin: 0.1rem auto;
      > div {
        width: 50%;
        height: 100%;
        font-size: 0.14rem;
        line-height: 0.23rem;
        color: @base-text-color;
        float: left;
        cursor: pointer;
        background: url(../assets/spot_tab_bg.png);
        background-size: 100% 100%;
      }
      .current {
        background: url(../assets/tab_bg_cur.png);
        background-size: 100% 100%;
      }
    }
    }
    #yuqingliebiaoChart{height: 4rem;}
</style>
